import React from "react";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { functions } from '../../helpers/Firebase';
import { Colxx } from "./CustomBootstrap";

const ResetPasswordModal = ({ 
  isOpen, 
  toggle, 
  resetPassword, 
  setResetPassword, 
  updatedProvider 
}) => {
  const handleReset = () => {
    const changeProviderPassword = functions().httpsCallable('updateRecords');
    changeProviderPassword({ 
      uid: updatedProvider?.key, 
      prop: { password: resetPassword.value } 
    }).then(function (result) {
      if (!result?.data?.error) {
        toggle(false);
      }
    });
  };

  return (
    <Modal isOpen={isOpen} backdrop="static">
      <ModalHeader>
        Reset Password
      </ModalHeader>
      <ModalBody>
        <Row>
          <Colxx xxs="12">
            <Label>
              Password
            </Label>
            <Input
              type="password"
              value={resetPassword?.value || ''}
              onChange={(e) =>
                setResetPassword({ ...resetPassword, value: e.target.value })
              }
            />
          </Colxx>
          <Colxx xxs="12" className="mt-4">
            <Label>
              Confirm Password
            </Label>
            <Input
              type="password"
              value={resetPassword?.confirmPassword || ''}
              onChange={(e) =>
                setResetPassword({ ...resetPassword, confirmPassword: e.target.value })
              }
            />
          </Colxx>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" outline onClick={() => toggle(false)}>
          Cancel
        </Button>
        <Button color="primary" className="top-right-button" onClick={handleReset}>
          Reset
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ResetPasswordModal;
